import { Box, CircularProgress, Fade } from "@mui/material";
import { useContext } from "react";
import { useCandidateHistoryQuery } from "../../../App/Queries/CandidateQueries";
import { CandidateContext } from "../../CandidateProfile";
import CandidateHistoryTable from "./Components/CandidateHistoryTable";

export default function CandidateUpdateHistory() {
  const { candidate } = useContext(CandidateContext);
  const { data: candidateHistory, isLoading: loadingCandidateHistory } = useCandidateHistoryQuery(
    candidate.id
  );

  if (candidateHistory === undefined || loadingCandidateHistory) {
    return (
      <Box sx={{ minHeight: 500, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Fade in={!loadingCandidateHistory} timeout={500}>
      <Box sx={{ position: "relative" }}>
        <CandidateHistoryTable
          tableData={candidateHistory}
          emptyMessage="No tracking data available for this Candidate"
        />
      </Box>
    </Fade>
  );
}
